const getCroppedImg = async (
  image: HTMLImageElement,
  crop: {
    x: number
    y: number
    width: number
    height: number
  },
  format: 'image/jpeg' | 'image/png' = 'image/jpeg',
  zoom = 1,
  panX = 0,
  panY = 0,
): Promise<Blob> => {
  if (!crop.width || !crop.height) {
    throw new Error('Crop size is invalid')
  }

  await image.decode()

  const ratioX = image.naturalWidth / image.width
  const ratioY = image.naturalHeight / image.height

  const canvas = document.createElement('canvas')

  const centerX = image.width / 2
  const centerY = image.height / 2

  const srcX = ((crop.x - panX - centerX) / zoom + centerX) * ratioX
  const srcY = ((crop.y - panY - centerY) / zoom + centerY) * ratioY
  const srcW = (crop.width / zoom) * ratioX
  const srcH = (crop.height / zoom) * ratioY

  canvas.width = Math.round(srcW)
  canvas.height = Math.round(srcH)

  const ctx = canvas.getContext('2d')
  if (!ctx) {
    throw new Error('2D context not available')
  }

  ctx.drawImage(
    image,
    Math.round(srcX),
    Math.round(srcY),
    Math.round(srcW),
    Math.round(srcH),
    0,
    0,
    canvas.width,
    canvas.height,
  )

  return new Promise<Blob>((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) {
        resolve(blob)
      } else {
        reject(new Error('Failed to generate cropped image'))
      }
    }, format)
  })
}

export default getCroppedImg
